/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'routeTrees',
		'routeTrees'
	],

	config: {
		preSelectBySortIndicator: false,
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'routeTrees',
				'selectRouteTree'
			]
		}
	},

	methods: {
		dataDealer: function(){
			if(!this.model.dirtyAssignedRoutes){
				this.model.dirtyAssignedRoutes = (this.getResourceRegisterContent('assignedRoutes') || {});
				this.model.selectionConfig = utils.replace({
					multiSelect: 	false,
					selectCascade: 	'',
					usePrimaryKeyAsObjectKeyDataFormat: false,
				}, this.getResourceRegisterContent('selectionConfig') || {});
			}

			const highlightRouteIDs = this.getResourceRegisterContent('highlightRouteIDs') || {};
			if(utils.collectionSize(highlightRouteIDs) > 0){
				this.model.highlightRouteIDs = highlightRouteIDs;
			}
		},

		checkOnceForFilterComponentPresets(){
			// respect presetFilters if treeFilter Component receives default values from caller component
			if(!this.model.filterComponentPresetsChecked){
				const presetFilterParams = (this.getResourceRegisterContent('treeFilters') || {}).presetFilterParams || {};
				if(utils.collectionSize(presetFilterParams) > 0){
					this.model.filterComponentPresetsChecked = true;
					this.setFilterParams(presetFilterParams)
				}
			}
		},

		preSelectEntities: function(entities){
			var multiSelect = (this.model.selectionConfig || {}).multiSelect || false;
			var indexes = [];
			for(var i in entities){
				var route = entities[i] || {};
				if(!route.unselect){
					indexes.push(this.getNodeIndex(route.routeID, 'route'));
					if(!multiSelect) break;
				}
			}
			var treeComponentIndex = Object.keys(this.model.states.trees).shift();
			if(multiSelect){
				this.checkNodes(indexes, treeComponentIndex, true);
			} else {
				this.selectNodeByIndex(indexes[0], treeComponentIndex, true)
			}
		},

		selectElement: function(routeID, select = true){
			var self = this;
			var getChildrenPromise = utils.promise.resolve([routeID]);

			if(self.model.selectionConfig.multiSelect && String(self.model.selectionConfig.selectCascade || '').match(/.*down.*/) !== null){
				getChildrenPromise = self.performAction(
					self.prepareAction('getRouteIDs', undefined, undefined, {
						source: {
							load: {
								data: {
									resourceFilters: {
										routeIDs: [routeID]
									}
								}
							}
						}
					})
				).then(function(context){
					return utils.promise.resolve((((context || {}).action || {}).response || {}).data || [routeID]);
				});
			}

			getChildrenPromise.then(function(routeIDs){
				if(self.model.selectionConfig.multiSelect){
					self.model.dirtyAssignedRoutes = self.model.dirtyAssignedRoutes || {};
				} else {
					self.model.dirtyAssignedRoutes = {};
				}
				var routeCounter = utils.collectionSize(self.model.dirtyAssignedRoutes);
				var routeFound = false;
				for(var routeID of routeIDs){
					routeFound = false
					if(self.model.selectionConfig.usePrimaryKeyAsObjectKeyDataFormat){
						if(self.model.dirtyAssignedRoutes[routeID]){
							self.model.dirtyAssignedRoutes[routeID].unselect = !select
						} else {
							self.model.dirtyAssignedRoutes[routeID] = {
								routeID,
								unselect: !select
							};
						}
					} else {
						for(var routeIndex in self.model.dirtyAssignedRoutes){
							if(self.model.dirtyAssignedRoutes[routeIndex].routeID == routeID){
								self.model.dirtyAssignedRoutes[routeIndex].unselect = !select;
								routeFound = true;
								break;
							}
						}
						if(!routeFound){
							self.model.dirtyAssignedRoutes[routeCounter++] = {
								routeID,
								unselect: !select
							};
						}
					}
				}

				// tell route-picker-button (or other decider) that the selection has been changed
				self.triggerClosest('onDecision', {
					decisionComponent: self,
					decisionType: 'submit',
					decisionOptions: self.config.decisionOptions || {},
					data: self.model.dirtyAssignedRoutes
				});

				if(!self.model.selectionConfig.multiSelect){
					self.closest('base_modal_modal', function(modal){
						modal.processDecision(modal, 'decisionComponent', 'assign');
					});
				}
			});
		},

		onTreeAction: function (data) {
			var self = this;
			var node = (((data || {}).onTreeActionOptions || {}).eventData || {}).node || {};
			var resource = (node.original || {}).resource || {};
			var routeID = resource.routeID;

			switch (data.onTreeActionOptions.eventType) {
				case 'ready.jstree':
					this.model.refreshDataInEffect = false;
					this.restoreSortIndicator();
					if(this.model.dirtyAssignedRoutes){
						self.preSelectEntities(self.model.dirtyAssignedRoutes);
					}
					break;

				case 'refresh.jstree':
					var numberOfElements = 0;
					for(var treeContainer of this.resourceData.trees || []){
						numberOfElements += (treeContainer.tree || []).length
					}
					if(numberOfElements === 0){
						this.$.addClass('showEmpty');
					} else {
						this.$.removeClass('showEmpty');
					}

					if(this.model.dirtyAssignedRoutes){
						self.preSelectEntities(self.model.dirtyAssignedRoutes);
					}

					this.restoreSortIndicator();
					this.model.onScrollLimitReached = false;
					// reset height after preventing scroll-bar-flickering between close_node and lazyload next nodes.
					$(data.onTreeActionOptions.event.target).height('');
					this.model.refreshDataInEffect = false;

					// select newNode if necessary
					if(this.config.selectNewNodeAfterRefresh && this.config.readyNodeID !== undefined){
						if(this.selectNodeByID(self.config.readyNodeID, self.config.readyNodeContext, undefined, true)){
							delete this.config.readyNodeID;
							return;
						}
					}
					break;


				case 'select_node.jstree':
					// show page actions if necessary
					if(routeID && !data.onTreeActionOptions.autoSelect) {
						this.backupSortIndicator(routeID, resource.sort, '#' + node.a_attr.id, true);
					}
					break;


				case 'close_node.jstree':
					// fix height to prevent scroll-bar-flickering between close_node and lazyload next nodes.
					var state = this.getTypeDependentState();
					var $tree = $(data.onTreeActionOptions.event.target);
					var height = $tree.height();
					$tree.height(height);

					// hide page actions if necessary
					if(routeID){
						state.parentNodeStates[routeID] = 0;
						this.backupSortIndicator(routeID, resource.sort, '#' + node.a_attr.id);
						this.refreshData();
					}
					break;

				case 'changed.jstree':
					if(routeID && (!data.onTreeActionOptions.autoSelect || ((self.config.decisionOptions || {}).decideOnAutoSelect))) {
						self.selectElement(routeID, ((data.onTreeActionOptions || {}).eventData || {}).action !== 'deselect_node', data.onTreeActionOptions.autoSelect);
					}
					break;
			}
		},

		onAttachDone: function(){
			// NOTE: prevent subActions from being appended
		}
	},

	// NOTE: prevent routeTrees handlers from being called for this selectRouteTrees-Component
	handlers: [
		{
			name: 'onSuccessfulLoginDialog',
			handle: function(callerComponent){
				// TODO: POI
				// TODO: check if route selector works properly with new error handling cases
				// this.model.refreshDataInEffect = false;
				// this.model.onScrollLimitReached = false;
				// this.refreshData();
			}
		}
	]
};
